import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import logo from '../../../assets/images/wm_cvm_logo_primary.png';

const LogoBrand = ({ linkTo }) => (
  <div className="tvt-header__logobrand">
    <Link className="tvt-header__logo" to={linkTo}>
      <img src={logo} srcSet={`${logo}`} alt="CVM Insights" />
    </Link>
  </div>
);

LogoBrand.propTypes = {
  linkTo: PropTypes.string
};

LogoBrand.defaultProps = {
  linkTo: '/'
};

export default LogoBrand;
